import { LocationSelect } from '@hakimo-ui/hakimo/feature-shared';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export function AddLocationField(props: Props) {
  const { value, onChange } = props;
  return (
    <div>
      <div className="dark:text-dark-secondary-text mb-1 block text-sm text-gray-700">
        Location
      </div>
      <div className="col-span-8">
        <LocationSelect locationId={value} onChange={onChange} />
      </div>
    </div>
  );
}
